import React from 'react';
import { Event } from '../types';
import Utils from '@/utils/util';
import { useAuth } from '@/lib/auth';
import { businessCurrency } from '@/features/Language/api/getCountryCurrency';
type RequestPaymentProps = {
  selectedAppointment: Event;
  totalAmount?: number;
};
export const AppointmentPreview = ({ selectedAppointment, totalAmount }: RequestPaymentProps) => {
  const { user } = useAuth();
  const currency = businessCurrency(user, 'USD');
  const name = selectedAppointment.room
    ? selectedAppointment.accomodationType === 'daycare'
      ? 'Daycare - ' + selectedAppointment.room.name
      : 'Boarding - ' + selectedAppointment.room.name
    : 'Grooming - ' + selectedAppointment.service.name;
  return (
    <div className="appointment-preview">
      <div className="left-section details">
        <p>{name}</p>
        {!selectedAppointment.accomodationType ||
        selectedAppointment.accomodationType === 'daycare' ? (
          <p>
            <span>
              {Utils.formatDateStringTz(
                selectedAppointment?.startTime,
                user?.activeLocation?.timezone,
                'ddd, DD MMM, yyyy'
              )}{' '}
            </span>
            <span className="seperator">| </span>
            <span>
              {Utils.formatDateStringTz(
                selectedAppointment?.startTime,
                user?.activeLocation?.timezone,
                'hh:mm A'
              )}{' '}
              -{' '}
              {Utils.formatDateStringTz(
                selectedAppointment?.endTime,
                user?.activeLocation?.timezone,
                'hh:mm A'
              )}
            </span>
          </p>
        ) : (
          <p>
            {Utils.formatDateStringTz(
              selectedAppointment?.startTime,
              user?.activeLocation?.timezone,
              'ddd, DD MMM, yyyy hh:mm A'
            )}{' '}
            -{' '}
            {Utils.formatDateStringTz(
              selectedAppointment?.endTime,
              user?.activeLocation?.timezone,
              'ddd, DD MMM, yyyy hh:mm A'
            )}
          </p>
        )}
      </div>
      <div className="right-section details">
        <p>
          {currency} {totalAmount}
        </p>
        <p>
          {(!selectedAppointment.accomodationType ||
            selectedAppointment.accomodationType === 'daycare') && (
            <div className="service-desc">
              {selectedAppointment?.duration ? Utils.getDuration(selectedAppointment?.duration) : 0}
            </div>
          )}
          {selectedAppointment.accomodationType === 'boarding' && (
            <div className="service-desc">
              {Utils.totalDaysBooked(
                selectedAppointment.startTime,
                selectedAppointment.endTime,
                user?.activeLocation?.timezone
              )}
            </div>
          )}
        </p>
      </div>
    </div>
  );
};
